module.exports = __webpack_public_path__ + "media/application/images/newsletter-bg-07579802b5f40091b6ff96b51f99a7db.jpg";